import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import {ModalManager} from './ModalManager';

const angular = require('angular');
const {element} = angular;

export const reactModalsModule = angular
  .module('app.core-utilities.react-modals', [])
  .factory('modalManager', init)
;

init.$inject = [
  '$modal',
  '$ngRedux',
  '$ionicClickBlock',
];

function init(
  $modal,
  $ngRedux,
  $ionicClickBlock,
) {
  const body = element(document.body);
  return new ModalManager({
    onOpen: (modalManager, modal) => {
      $ionicClickBlock.show(600);

      if (modal.config.isLegacy) {
        body.addClass('modal-open');
      }
    },
    onClose: (modalManager) => {
      if (get(window, 'cordova.plugins.Keyboard')) {
        window.cordova.plugins.Keyboard.close();
      }

      if (!hasLegacyModal(modalManager)) {
        body.removeClass('modal-open');
      }
    },
  }, $ngRedux);

  function hasLegacyModal(modalManager) {
    const modals = modalManager.modalStack.stack;
    if (modals.length > 0 || $modal.stack.length > 0) {
      const index = findIndex(modals, modal => modal.config ? modal.config.isLegacy : false);
      return index > -1;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/index.js